export function ActivityCircleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='0.666992' width='20' height='20' rx='10' fill='currentColor' />
      <path
        d='M17.3333 10H14.6667L12.6667 16L8.66667 4L6.66667 10H4'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
